import {useRouter} from 'next/router';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import useSpecialties from '@/src/jobPortal/common/hooks/useSpecialties';
import FilterRow from '@/src/Search/components/FilterRow';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

import css from '../styles/FilterRow.module.css';

const SpecialtiesFilter = () => {
  const {specialties} = useSpecialties();
  // @ts-ignore
  const {onMultipleFilterClickHandle} = useSearchFilters();
  const {query, locale} = useRouter();

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.specialtyFilterTitle'} />
        </Text>
      }
    >
      <FilterRow>
        <div className={css.checkboxesMaxHeight}>
          {specialties?.map((specialty) => (
            <div key={specialty.id} className={css.checkboxes}>
              <CheckboxCommon
                id={`specialties${specialty.id}`}
                name={specialty[`name_${locale}`]}
                label={specialty[`name_${locale}`]}
                data-filter-name={SEARCH_FILTERS.SPECIALTIES}
                data-value={specialty.id.toString()}
                checked={
                  !!query[SEARCH_FILTERS.SPECIALTIES] &&
                  // @ts-ignore
                  JSON.parse([query[SEARCH_FILTERS.SPECIALTIES]]).includes(
                    String(specialty.id)
                  )
                }
                onChange={onMultipleFilterClickHandle}
                isSemibold
                error={undefined}
              />
            </div>
          ))}
        </div>
      </FilterRow>
    </SimpleCollapse>
  );
};

export default SpecialtiesFilter;
